export default "__VITE_ASSET__CbHTjOBh__"